import React from "react";
import PaintingCompetition from "../FooterTopMenuPages/AzadiKaAmritMahotsav/PaintingCompetition";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useLocation } from "react-router-dom";
import useSeo from "../../hooks/useSeo";

const BeePaintingCompetition = () => {
  const { pathname } = useLocation();
  const { innerBannerImage, innerBannerTitle } = useSeo({ pathname });

  return (
    <>
      <InnerBannerBreadcrumb
        titleLink="/bee-painting-competition"
        levelTwo={false}
        levelThree={false}
        bannerImage={innerBannerImage}
        title={innerBannerTitle}
        isActive={innerBannerTitle}
      />
      <div className="inner-container">
        <div className="container">
          {/* container */}
          <PaintingCompetition />
        </div>
      </div>
    </>
  );
};

export default BeePaintingCompetition;
